import { render, staticRenderFns } from "./VideoView.vue?vue&type=template&id=6e32a448&scoped=true"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"
import style0 from "./VideoView.vue?vue&type=style&index=0&id=6e32a448&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e32a448",
  null
  
)

export default component.exports